import { TAvailableConfigValues } from '@customTypes/common';

export enum EABRRule {
  THROUGHPUT_ESTIMATOR = 'throughputEstimator',
  DROPPED_FRAMES_ESTIMATOR = 'droppedFramesEstimator',
  SWITCH_HISTORY = 'switchHistory',
  INSUFFICIENT_BUFFER = 'insufficientBuffer',
  MINIMAL_BUFFER_TO_INCREASE = 'minimalBufferToIncrease',
  DELTA_BUFFER = 'deltaBuffer',
  MAX_RESOLUTION_ESTIMATOR = 'maxResolution',
}

export interface IAbrControllerConfig {
  enabledABRRules: EABRRule[];
  cooldownPeriod: number;
  minimalBufferAmountToSwitchUp: number;
  isLadderIncrease: boolean;
}

export const defaultAbrControllerConfig: IAbrControllerConfig = {
  enabledABRRules: [
    EABRRule.THROUGHPUT_ESTIMATOR,
    EABRRule.SWITCH_HISTORY,
    EABRRule.MINIMAL_BUFFER_TO_INCREASE,
    EABRRule.INSUFFICIENT_BUFFER,
    EABRRule.MAX_RESOLUTION_ESTIMATOR,
  ],
  cooldownPeriod: 10000,
  minimalBufferAmountToSwitchUp: 500,
  isLadderIncrease: false,
};

export const availableAbrControllerConfigValues: TAvailableConfigValues<IAbrControllerConfig> = {
  enabledABRRules: {
    isMultiple: true,
    values: [
      EABRRule.DROPPED_FRAMES_ESTIMATOR,
      EABRRule.THROUGHPUT_ESTIMATOR,
      EABRRule.SWITCH_HISTORY,
      EABRRule.MINIMAL_BUFFER_TO_INCREASE,
      EABRRule.INSUFFICIENT_BUFFER,
      EABRRule.DELTA_BUFFER,
      EABRRule.MAX_RESOLUTION_ESTIMATOR,
    ],
  },
};
